import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../css/main/AuthError.css';
const AuthError: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const message = searchParams.get('message') || 'Authentication failed. Please try again.';
    const handleGoBack = () => {
        navigate('/');
    };
    return (
        <div className="auth-error-container">
            <div className="auth-error-content">
                <img src="/401-error.png" alt="Authentication Error" className="auth-error-image" />
                <p className="auth-error-message">{message}</p>
                <button className="auth-error-back-button" onClick={handleGoBack}>  Go Home Page</button>
            </div>
        </div>
    );
};
export default AuthError;